module.exports = __webpack_public_path__ + "img/dm.46f58d40.svg";